import { BulkCertificateCreate } from 'pages/certificates_management/bulk_certificates';
import { generateResources } from 'utils/GenerateResouces';

const resource = {
  name: 'bulk_course_certificates',
  label: 'Adicionar certificados em lote',
  create: BulkCertificateCreate,
  actions: ['create'],
  parentName: 'certificate_management'
};

export default generateResources(resource);

